var React = require('react');

module.exports = {
  className: 'pagination',
  tags: {
      container: {
          tag: 'ul'
      },
      segment: {
          tag: 'li'
      },
      ellipsis: {
          tag: 'li',
          props: {
              className: 'disabled',
              children: React.createElement('span', null, '…')
          }
      },
      link: {
          tag: 'a',
          props: {
              href: '#'
          }
      }
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/react-pagify-preset-bootstrap/index.js
// module id = 870
// module chunks = 0